// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Select,
//   DatePicker,
//   Button,
//   Statistic,
//   Table,
//   Tabs,
//   Tag,
//   Space,
//   Tooltip,
//   Empty,
//   message,
// } from "antd";
// import {
//   DownloadOutlined,
//   ReloadOutlined,
//   CarOutlined,
//   DashboardOutlined,
// } from "@ant-design/icons";
// import moment from "moment";

// import {
//   get_ConsommationCarburant,
//   export_ConsommationCarburant,
// } from "../../../api/dashboard";
// // NOTE : adapte ce chemin si ta liste de camions vient d'un autre module
// // (ex. api/camion.js -> get_Camion()).
// import { get_listeCamion as get_Camion } from "../../../api/camion";

// const { RangePicker } = DatePicker;

// const FORMAT_API = "YYYY-MM-DD";

// const SENS_TAG = {
//   aller: { color: "blue", label: "Aller" },
//   retour: { color: "green", label: "Retour" },
//   supplementaire: { color: "orange", label: "Supplémentaire" },
// };

// export default function ConsommationCarburant({ camionIdLocked = null }) {
//   const [camions, setCamions] = useState([]);
//   const [camionId, setCamionId] = useState(camionIdLocked);
//   const [periode, setPeriode] = useState([
//     moment().startOf("month"),
//     moment(),
//   ]);

//   const [loading, setLoading] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [data, setData] = useState(null);

//   // ------------------------------------------------------------------
//   // Chargement de la liste des camions (pour le filtre) — inutile si le
//   // camion est déjà imposé par le parent (camionIdLocked)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     if (camionIdLocked) return;
//     get_Camion()
//       .then((res) => setCamions(res?.data || res || []))
//       .catch(() => setCamions([]));
//   }, [camionIdLocked]);

//   const buildParams = useCallback(() => {
//     const [start, end] = periode || [];
//     return {
//       camion_id: camionId || undefined,
//       start_date: start ? start.format(FORMAT_API) : undefined,
//       end_date: end ? end.format(FORMAT_API) : undefined,
//     };
//   }, [camionId, periode]);

//   // ------------------------------------------------------------------
//   // Chargement des données du dashboard
//   // ------------------------------------------------------------------
//   const fetchData = useCallback(() => {
//     setLoading(true);
//     get_ConsommationCarburant(buildParams())
//       .then((res) => setData(res?.data || null))
//       .catch(() => {
//         message.error("Impossible de charger la consommation carburant.");
//         setData(null);
//       })
//       .finally(() => setLoading(false));
//   }, [buildParams]);

//   useEffect(() => {
//     fetchData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ------------------------------------------------------------------
//   // Export Excel
//   // ------------------------------------------------------------------
//   const handleExport = async () => {
//     setExporting(true);
//     try {
//       const blob = await export_ConsommationCarburant(buildParams());
//       const url = window.URL.createObjectURL(blob);
//       const [start, end] = periode || [];
//       const nomFichier = `consommation_carburant_${
//         start ? start.format(FORMAT_API) : "debut"
//       }_${end ? end.format(FORMAT_API) : "fin"}.xlsx`;

//       const lien = document.createElement("a");
//       lien.href = url;
//       lien.download = nomFichier;
//       document.body.appendChild(lien);
//       lien.click();
//       lien.remove();
//       window.URL.revokeObjectURL(url);

//       message.success("Export Excel généré.");
//     } catch (error) {
//       message.error("Erreur lors de la génération de l'export Excel.");
//     } finally {
//       setExporting(false);
//     }
//   };

//   // ------------------------------------------------------------------
//   // KPIs globaux (agrégés sur les camions actuellement affichés)
//   // ------------------------------------------------------------------
//   const kpis = useMemo(() => {
//     const parCamion = data?.par_camion || [];
//     const distance = parCamion.reduce((s, c) => s + (c.distance_totale_km || 0), 0);
//     const carburant = parCamion.reduce((s, c) => s + (c.carburant_total_l || 0), 0);
//     const nbTrajets = parCamion.reduce((s, c) => s + (c.nb_trajets || 0), 0);
//     return {
//       distance,
//       carburant,
//       nbTrajets,
//       nbCamions: parCamion.length,
//       consoMoyenne: distance > 0 ? Math.round((carburant / distance) * 100 * 100) / 100 : null,
//     };
//   }, [data]);

//   // ------------------------------------------------------------------
//   // Colonnes des tableaux
//   // ------------------------------------------------------------------
//   const colonnesParCamion = [
//     { title: "Camion", dataIndex: "camion_id", key: "camion_id", sorter: (a, b) => a.camion_id - b.camion_id },
//     { title: "Trajets", dataIndex: "nb_trajets", key: "nb_trajets", sorter: (a, b) => a.nb_trajets - b.nb_trajets },
//     {
//       title: "Distance totale (km)",
//       dataIndex: "distance_totale_km",
//       key: "distance_totale_km",
//       sorter: (a, b) => a.distance_totale_km - b.distance_totale_km,
//       render: (v) => v?.toLocaleString("fr-FR"),
//     },
//     {
//       title: "Carburant total (L)",
//       dataIndex: "carburant_total_l",
//       key: "carburant_total_l",
//       sorter: (a, b) => a.carburant_total_l - b.carburant_total_l,
//       render: (v) => v?.toLocaleString("fr-FR"),
//     },
//     {
//       title: "Conso moyenne (L/100km)",
//       dataIndex: "conso_moyenne_l_100km",
//       key: "conso_moyenne_l_100km",
//       sorter: (a, b) => (a.conso_moyenne_l_100km || 0) - (b.conso_moyenne_l_100km || 0),
//       render: (v) => (v != null ? <Tag color={v > 40 ? "red" : "green"}>{v} L/100km</Tag> : "-"),
//     },
//     {
//       title: "Carburant moyen / trajet (L)",
//       dataIndex: "carburant_moyen_par_trajet",
//       key: "carburant_moyen_par_trajet",
//     },
//   ];

//   const colonnesAllerRetour = [
//     { title: "Facture", dataIndex: "facture_id", key: "facture_id" },
//     { title: "Camion", dataIndex: "camion_id", key: "camion_id" },
//     { title: "Distance aller (km)", dataIndex: "distance_aller_km", key: "distance_aller_km" },
//     { title: "Carburant aller (L)", dataIndex: "carburant_aller_l", key: "carburant_aller_l" },
//     {
//       title: "Conso aller",
//       dataIndex: "conso_aller_l_100km",
//       key: "conso_aller_l_100km",
//       render: (v) => (v != null ? `${v} L/100km` : "-"),
//     },
//     { title: "Distance retour (km)", dataIndex: "distance_retour_km", key: "distance_retour_km" },
//     { title: "Carburant retour (L)", dataIndex: "carburant_retour_l", key: "carburant_retour_l" },
//     {
//       title: "Conso retour",
//       dataIndex: "conso_retour_l_100km",
//       key: "conso_retour_l_100km",
//       render: (v) => (v != null ? `${v} L/100km` : "-"),
//     },
//     {
//       title: "Conso globale",
//       dataIndex: "conso_globale_l_100km",
//       key: "conso_globale_l_100km",
//       render: (v) => (v != null ? <Tag color="blue">{v} L/100km</Tag> : "-"),
//     },
//   ];

//   const colonnesDetail = [
//     { title: "Trajet", dataIndex: "trajet_id", key: "trajet_id" },
//     { title: "Camion", dataIndex: "camion_id", key: "camion_id" },
//     { title: "Facture", dataIndex: "facture_id", key: "facture_id" },
//     {
//       title: "Sens",
//       dataIndex: "sens",
//       key: "sens",
//       filters: Object.entries(SENS_TAG).map(([value, { label }]) => ({ text: label, value })),
//       onFilter: (value, record) => record.sens === value,
//       render: (sens) => {
//         const cfg = SENS_TAG[sens] || { color: "default", label: sens };
//         return <Tag color={cfg.color}>{cfg.label}</Tag>;
//       },
//     },
//     { title: "Départ", dataIndex: "date_depart", key: "date_depart" },
//     { title: "Arrivée", dataIndex: "date_arrive", key: "date_arrive" },
//     { title: "Distance (km)", dataIndex: "distance_km", key: "distance_km", sorter: (a, b) => a.distance_km - b.distance_km },
//     { title: "Carburant (L)", dataIndex: "carburant_consomme", key: "carburant_consomme" },
//     {
//       title: "Conso (L/100km)",
//       dataIndex: "conso_l_100km",
//       key: "conso_l_100km",
//       sorter: (a, b) => (a.conso_l_100km || 0) - (b.conso_l_100km || 0),
//     },
//   ];

//   return (
//     <div style={{ padding: 16 }}>
//       {/* --------------------------- Filtres --------------------------- */}
//       <Card style={{ marginBottom: 16 }}>
//         <Row gutter={[16, 16]} align="middle" justify="space-between">
//           <Col flex="auto">
//             <Space wrap size="middle">
//               {!camionIdLocked && (
//                 <Select
//                   allowClear
//                   showSearch
//                   placeholder="Tous les camions"
//                   style={{ width: 220 }}
//                   value={camionId || undefined}
//                   onChange={(v) => setCamionId(v)}
//                   optionFilterProp="children"
//                 >
//                   {camions.map((c) => (
//                     <Select.Option key={c.id} value={c.id}>
//                       {c.imm || c.reference || `Camion #${c.id}`}
//                     </Select.Option>
//                   ))}
//                 </Select>
//               )}

//               <RangePicker
//                 value={periode}
//                 onChange={(v) => setPeriode(v)}
//                 format="DD/MM/YYYY"
//                 allowClear={false}
//               />

//               <Button icon={<ReloadOutlined />} onClick={fetchData} loading={loading}>
//                 Rechercher
//               </Button>
//             </Space>
//           </Col>

//           <Col>
//             <Tooltip title="Génère un fichier Excel avec les filtres actuels">
//               <Button
//                 type="primary"
//                 icon={<DownloadOutlined />}
//                 onClick={handleExport}
//                 loading={exporting}
//               >
//                 Exporter en Excel
//               </Button>
//             </Tooltip>
//           </Col>
//         </Row>
//       </Card>

//       {/* ----------------------------- KPIs ----------------------------- */}
//       <Row gutter={16} style={{ marginBottom: 16 }}>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic
//               title="Camions"
//               value={kpis.nbCamions}
//               prefix={<CarOutlined />}
//             />
//           </Card>
//         </Col>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic title="Trajets" value={kpis.nbTrajets} />
//           </Card>
//         </Col>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic
//               title="Distance totale"
//               value={kpis.distance}
//               suffix="km"
//               precision={0}
//             />
//           </Card>
//         </Col>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic
//               title="Conso moyenne"
//               value={kpis.consoMoyenne ?? "-"}
//               suffix={kpis.consoMoyenne != null ? "L/100km" : ""}
//               prefix={<DashboardOutlined />}
//               precision={2}
//             />
//           </Card>
//         </Col>
//       </Row>

//       {/* --------------------------- Tableaux --------------------------- */}
//       <Card>
//         <Tabs
//           defaultActiveKey="par_camion"
//           items={[
//             {
//               key: "par_camion",
//               label: "Par camion",
//               children: (
//                 <Table
//                   rowKey="camion_id"
//                   loading={loading}
//                   columns={colonnesParCamion}
//                   dataSource={data?.par_camion || []}
//                   pagination={{ pageSize: 10, showSizeChanger: true }}
//                   locale={{ emptyText: <Empty description="Aucune donnée sur la période" /> }}
//                   scroll={{ x: true }}
//                 />
//               ),
//             },
//             {
//               key: "aller_retour",
//               label: "Aller / Retour",
//               children: (
//                 <Table
//                   rowKey="facture_id"
//                   loading={loading}
//                   columns={colonnesAllerRetour}
//                   dataSource={data?.par_voyage || []}
//                   pagination={{ pageSize: 10, showSizeChanger: true }}
//                   locale={{ emptyText: <Empty description="Aucune donnée sur la période" /> }}
//                   scroll={{ x: true }}
//                 />
//               ),
//             },
//             {
//               key: "detail",
//               label: "Détail des trajets",
//               children: (
//                 <Table
//                   rowKey="trajet_id"
//                   loading={loading}
//                   columns={colonnesDetail}
//                   dataSource={data?.detail_trajets || []}
//                   pagination={{ pageSize: 15, showSizeChanger: true }}
//                   locale={{ emptyText: <Empty description="Aucune donnée sur la période" /> }}
//                   scroll={{ x: true }}
//                 />
//               ),
//             },
//           ]}
//         />
//       </Card>
//     </div>
//   );
// }

// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Select,
//   DatePicker,
//   Button,
//   Statistic,
//   Table,
//   Tabs,
//   Tag,
//   Space,
//   Tooltip,
//   Empty,
//   message,
// } from "antd";
// import {
//   DownloadOutlined,
//   ReloadOutlined,
//   CarOutlined,
//   DashboardOutlined,
// } from "@ant-design/icons";
// import moment from "moment";

// import {
//   get_ConsommationCarburant,
//   export_ConsommationCarburant,
// } from "../../../api/dashboard";
// // NOTE : adapte ce chemin si ta liste de camions vient d'un autre module
// // (ex. api/camion.js -> get_Camion()).
// import { get_listeCamion as get_Camion } from "../../../api/camion";

// const { RangePicker } = DatePicker;

// const FORMAT_API = "YYYY-MM-DD";

// const SENS_TAG = {
//   aller: { color: "blue", label: "Aller" },
//   retour: { color: "green", label: "Retour" },
//   supplementaire: { color: "orange", label: "Supplémentaire" },
// };

// export default function ConsommationCarburant({ camionIdLocked = null }) {
//   const [camions, setCamions] = useState([]);
//   const [camionId, setCamionId] = useState(camionIdLocked);
//   const [periode, setPeriode] = useState([
//     moment().startOf("month"),
//     moment(),
//   ]);

//   const [loading, setLoading] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [data, setData] = useState(null);

//   // ------------------------------------------------------------------
//   // Chargement de la liste des camions (pour le filtre) — inutile si le
//   // camion est déjà imposé par le parent (camionIdLocked)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     if (camionIdLocked) return;
//     get_Camion()
//       .then((res) => setCamions(res?.data || res || []))
//       .catch(() => setCamions([]));
//   }, [camionIdLocked]);

//   const buildParams = useCallback(() => {
//     const [start, end] = periode || [];
//     return {
//       camion_id: camionId || undefined,
//       start_date: start ? start.format(FORMAT_API) : undefined,
//       end_date: end ? end.format(FORMAT_API) : undefined,
//     };
//   }, [camionId, periode]);

//   // ------------------------------------------------------------------
//   // Chargement des données du dashboard
//   // ------------------------------------------------------------------
//   const fetchData = useCallback(() => {
//     setLoading(true);
//     get_ConsommationCarburant(buildParams())
//       .then((res) => setData(res?.data || null))
//       .catch(() => {
//         message.error("Impossible de charger la consommation carburant.");
//         setData(null);
//       })
//       .finally(() => setLoading(false));
//   }, [buildParams]);

//   useEffect(() => {
//     fetchData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ------------------------------------------------------------------
//   // Export Excel
//   // ------------------------------------------------------------------
//   const handleExport = async () => {
//     setExporting(true);
//     try {
//       const blob = await export_ConsommationCarburant(buildParams());
//       const url = window.URL.createObjectURL(blob);
//       const [start, end] = periode || [];
//       const nomFichier = `consommation_carburant_${
//         start ? start.format(FORMAT_API) : "debut"
//       }_${end ? end.format(FORMAT_API) : "fin"}.xlsx`;

//       const lien = document.createElement("a");
//       lien.href = url;
//       lien.download = nomFichier;
//       document.body.appendChild(lien);
//       lien.click();
//       lien.remove();
//       window.URL.revokeObjectURL(url);

//       message.success("Export Excel généré.");
//     } catch (error) {
//       message.error("Erreur lors de la génération de l'export Excel.");
//     } finally {
//       setExporting(false);
//     }
//   };

//   // ------------------------------------------------------------------
//   // KPIs globaux (agrégés sur les camions actuellement affichés)
//   // ------------------------------------------------------------------
//   const kpis = useMemo(() => {
//     const parCamion = data?.par_camion || [];
//     const distance = parCamion.reduce((s, c) => s + (c.distance_totale_km || 0), 0);
//     const carburant = parCamion.reduce((s, c) => s + (c.carburant_total_l || 0), 0);
//     const nbTrajets = parCamion.reduce((s, c) => s + (c.nb_trajets || 0), 0);
//     return {
//       distance,
//       carburant,
//       nbTrajets,
//       nbCamions: parCamion.length,
//       consoMoyenne: distance > 0 ? Math.round((carburant / distance) * 100 * 100) / 100 : null,
//     };
//   }, [data]);

//   // ------------------------------------------------------------------
//   // Colonnes des tableaux
//   // ------------------------------------------------------------------
//   const colonnesParCamion = [
//     { title: "Camion", dataIndex: "camion_id", key: "camion_id", sorter: (a, b) => a.camion_id - b.camion_id },
//     { title: "Trajets", dataIndex: "nb_trajets", key: "nb_trajets", sorter: (a, b) => a.nb_trajets - b.nb_trajets },
//     {
//       title: "Distance totale (km)",
//       dataIndex: "distance_totale_km",
//       key: "distance_totale_km",
//       sorter: (a, b) => a.distance_totale_km - b.distance_totale_km,
//       render: (v) => v?.toLocaleString("fr-FR"),
//     },
//     {
//       title: "Carburant total (L)",
//       dataIndex: "carburant_total_l",
//       key: "carburant_total_l",
//       sorter: (a, b) => a.carburant_total_l - b.carburant_total_l,
//       render: (v) => v?.toLocaleString("fr-FR"),
//     },
//     {
//       title: "Conso moyenne (L/100km)",
//       dataIndex: "conso_moyenne_l_100km",
//       key: "conso_moyenne_l_100km",
//       sorter: (a, b) => (a.conso_moyenne_l_100km || 0) - (b.conso_moyenne_l_100km || 0),
//       render: (v) => (v != null ? <Tag color={v > 40 ? "red" : "green"}>{v} L/100km</Tag> : "-"),
//     },
//     {
//       title: "Carburant moyen / trajet (L)",
//       dataIndex: "carburant_moyen_par_trajet",
//       key: "carburant_moyen_par_trajet",
//     },
//   ];

//   const colonnesAllerRetour = [
//     { title: "Facture", dataIndex: "facture_id", key: "facture_id" },
//     { title: "Camion", dataIndex: "camion_id", key: "camion_id" },
//     { title: "Distance aller (km)", dataIndex: "distance_aller_km", key: "distance_aller_km" },
//     { title: "Carburant aller (L)", dataIndex: "carburant_aller_l", key: "carburant_aller_l" },
//     {
//       title: "Conso aller",
//       dataIndex: "conso_aller_l_100km",
//       key: "conso_aller_l_100km",
//       render: (v) => (v != null ? `${v} L/100km` : "-"),
//     },
//     { title: "Distance retour (km)", dataIndex: "distance_retour_km", key: "distance_retour_km" },
//     { title: "Carburant retour (L)", dataIndex: "carburant_retour_l", key: "carburant_retour_l" },
//     {
//       title: "Conso retour",
//       dataIndex: "conso_retour_l_100km",
//       key: "conso_retour_l_100km",
//       render: (v) => (v != null ? `${v} L/100km` : "-"),
//     },
//     {
//       title: "Conso globale",
//       dataIndex: "conso_globale_l_100km",
//       key: "conso_globale_l_100km",
//       render: (v) => (v != null ? <Tag color="blue">{v} L/100km</Tag> : "-"),
//     },
//   ];

//   const colonnesDetail = [
//     { title: "Trajet", dataIndex: "trajet_id", key: "trajet_id" },
//     { title: "Camion", dataIndex: "camion_id", key: "camion_id" },
//     { title: "Facture", dataIndex: "facture_id", key: "facture_id" },
//     {
//       title: "Sens",
//       dataIndex: "sens",
//       key: "sens",
//       filters: Object.entries(SENS_TAG).map(([value, { label }]) => ({ text: label, value })),
//       onFilter: (value, record) => record.sens === value,
//       render: (sens) => {
//         const cfg = SENS_TAG[sens] || { color: "default", label: sens };
//         return <Tag color={cfg.color}>{cfg.label}</Tag>;
//       },
//     },
//     { title: "Départ", dataIndex: "date_depart", key: "date_depart" },
//     { title: "Arrivée", dataIndex: "date_arrive", key: "date_arrive" },
//     { title: "Distance (km)", dataIndex: "distance_km", key: "distance_km", sorter: (a, b) => a.distance_km - b.distance_km },
//     { title: "Carburant (L)", dataIndex: "carburant_consomme", key: "carburant_consomme" },
//     {
//       title: "Conso (L/100km)",
//       dataIndex: "conso_l_100km",
//       key: "conso_l_100km",
//       sorter: (a, b) => (a.conso_l_100km || 0) - (b.conso_l_100km || 0),
//     },
//   ];

//   return (
//     <div style={{ padding: 16 }}>
//       {/* --------------------------- Filtres --------------------------- */}
//       <Card style={{ marginBottom: 16 }}>
//         <Row gutter={[16, 16]} align="middle" justify="space-between">
//           <Col flex="auto">
//             <Space wrap size="middle">
//               {!camionIdLocked && (
//                 <Select
//                   allowClear
//                   showSearch
//                   placeholder="Tous les camions"
//                   style={{ width: 220 }}
//                   value={camionId || undefined}
//                   onChange={(v) => setCamionId(v)}
//                   optionFilterProp="children"
//                 >
//                   {camions.map((c) => (
//                     <Select.Option key={c.id} value={c.id}>
//                       {c.imm || c.reference || `Camion #${c.id}`}
//                     </Select.Option>
//                   ))}
//                 </Select>
//               )}

//               <RangePicker
//                 value={periode}
//                 onChange={(v) => setPeriode(v)}
//                 format="DD/MM/YYYY"
//                 allowClear={false}
//               />

//               <Button icon={<ReloadOutlined />} onClick={fetchData} loading={loading}>
//                 Rechercher
//               </Button>
//             </Space>
//           </Col>

//           <Col>
//             <Tooltip title="Génère un fichier Excel avec les filtres actuels">
//               <Button
//                 type="primary"
//                 icon={<DownloadOutlined />}
//                 onClick={handleExport}
//                 loading={exporting}
//               >
//                 Exporter en Excel
//               </Button>
//             </Tooltip>
//           </Col>
//         </Row>
//       </Card>

//       {/* ----------------------------- KPIs ----------------------------- */}
//       <Row gutter={16} style={{ marginBottom: 16 }}>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic
//               title="Camions"
//               value={kpis.nbCamions}
//               prefix={<CarOutlined />}
//             />
//           </Card>
//         </Col>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic title="Trajets" value={kpis.nbTrajets} />
//           </Card>
//         </Col>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic
//               title="Distance totale"
//               value={kpis.distance}
//               suffix="km"
//               precision={0}
//             />
//           </Card>
//         </Col>
//         <Col xs={12} md={6}>
//           <Card loading={loading}>
//             <Statistic
//               title="Conso moyenne"
//               value={kpis.consoMoyenne ?? "-"}
//               suffix={kpis.consoMoyenne != null ? "L/100km" : ""}
//               prefix={<DashboardOutlined />}
//               precision={2}
//             />
//           </Card>
//         </Col>
//       </Row>

//       {/* --------------------------- Tableaux --------------------------- */}
//       <Card>
//         <Tabs
//           defaultActiveKey="par_camion"
//           items={[
//             {
//               key: "par_camion",
//               label: "Par camion",
//               children: (
//                 <Table
//                   rowKey="camion_id"
//                   loading={loading}
//                   columns={colonnesParCamion}
//                   dataSource={data?.par_camion || []}
//                   pagination={{ pageSize: 10, showSizeChanger: true }}
//                   locale={{ emptyText: <Empty description="Aucune donnée sur la période" /> }}
//                   scroll={{ x: true }}
//                 />
//               ),
//             },
//             {
//               key: "aller_retour",
//               label: "Aller / Retour",
//               children: (
//                 <Table
//                   rowKey="facture_id"
//                   loading={loading}
//                   columns={colonnesAllerRetour}
//                   dataSource={data?.par_voyage || []}
//                   pagination={{ pageSize: 10, showSizeChanger: true }}
//                   locale={{ emptyText: <Empty description="Aucune donnée sur la période" /> }}
//                   scroll={{ x: true }}
//                 />
//               ),
//             },
//             {
//               key: "detail",
//               label: "Détail des trajets",
//               children: (
//                 <Table
//                   rowKey="trajet_id"
//                   loading={loading}
//                   columns={colonnesDetail}
//                   dataSource={data?.detail_trajets || []}
//                   pagination={{ pageSize: 15, showSizeChanger: true }}
//                   locale={{ emptyText: <Empty description="Aucune donnée sur la période" /> }}
//                   scroll={{ x: true }}
//                 />
//               ),
//             },
//           ]}
//         />
//       </Card>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Card,
  Row,
  Col,
  Select,
  DatePicker,
  Button,
  Table,
  Tabs,
  Tag,
  Space,
  Tooltip,
  Empty,
  message,
} from "antd";
import {
  DownloadOutlined,
  ReloadOutlined,
  CarOutlined,
  DashboardOutlined,
  FireOutlined,
  EnvironmentOutlined,
  LineChartOutlined,
  TableOutlined,
} from "@ant-design/icons";
import moment from "moment";

import {
  get_ConsommationCarburant,
  export_ConsommationCarburant,
} from "../../../api/dashboard";

// NOTE : adapte ce chemin si ta liste de camions vient d'un autre module.
import { get_listeCamion as get_Camion } from "../../../api/camion";

const { RangePicker } = DatePicker;

const FORMAT_API = "YYYY-MM-DD";

const SENS_TAG = {
  aller: { color: "blue", label: "Aller" },
  retour: { color: "green", label: "Retour" },
  supplementaire: { color: "orange", label: "Supplémentaire" },
};

// Palette des KPI : dégradé plein et saturé par carte, façon tuiles de synthèse.
const KPI_THEME = {
  trajets: {
    gradient: "linear-gradient(135deg, #4a5cf5 0%, #7b6bf0 100%)",
  },
  distance: {
    gradient: "linear-gradient(135deg, #7c3aed 0%, #a675f2 100%)",
  },
  carburant: {
    gradient: "linear-gradient(135deg, #ea8c0e 0%, #f5ac52 100%)",
  },
  conso: {
    gradient: "linear-gradient(135deg, #0d8fa6 0%, #3fb9c9 100%)",
  },
};

/* -------------------------------------------------------------------------- */
/* Helpers graphiques                                                         */
/* -------------------------------------------------------------------------- */

const formatNumber = (value, digits = 0) => {
  if (value == null || Number.isNaN(Number(value))) return "-";
  return Number(value).toLocaleString("fr-FR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

const getDateKey = (row) => {
  const raw = row?.date_depart || row?.date_arrive || row?.create_at;
  if (!raw) return null;

  const date = moment(raw);
  return date.isValid() ? date.format("DD/MM") : null;
};

/* -------------------------------------------------------------------------- */
/* Carte KPI réutilisable                                                     */
/* -------------------------------------------------------------------------- */

function KpiCard({ gradient, icon, title, value, suffix, subtitle, loading }) {
  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 16,
        padding: "16px 18px",
        minHeight: 104,
        background: gradient,
        color: "#fff",
        boxShadow: "0 6px 18px rgba(15, 23, 42, 0.14)",
      }}
    >
      {/* Bulles décoratives */}
      <div
        style={{
          position: "absolute",
          top: -34,
          right: -18,
          width: 110,
          height: 110,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.14)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: -46,
          right: 26,
          width: 92,
          height: 92,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.10)",
        }}
      />

      <div style={{ position: "relative", zIndex: 1 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 9,
            marginBottom: 12,
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 9,
              background: "rgba(255,255,255,0.22)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {React.cloneElement(icon, {
              style: { fontSize: 15, color: "#fff" },
            })}
          </div>
          <span style={{ fontSize: 13, fontWeight: 600, opacity: 0.95 }}>
            {title}
          </span>
        </div>

        <div style={{ fontSize: 25, fontWeight: 800, lineHeight: 1.1 }}>
          {loading ? "…" : value}
          {suffix ? (
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                marginLeft: 5,
                opacity: 0.9,
              }}
            >
              {suffix}
            </span>
          ) : null}
        </div>

        {subtitle ? (
          <div style={{ fontSize: 12, opacity: 0.85, marginTop: 5 }}>
            {subtitle}
          </div>
        ) : null}
      </div>
    </div>
  );
}

// Transforme une liste de points {x, y} en tracé SVG lissé (spline Catmull-Rom -> Bézier).
function buildSmoothPath(coords) {
  if (coords.length < 2) return "";

  let d = `M ${coords[0].x},${coords[0].y} `;

  for (let i = 0; i < coords.length - 1; i++) {
    const p0 = coords[i - 1] || coords[i];
    const p1 = coords[i];
    const p2 = coords[i + 1];
    const p3 = coords[i + 2] || p2;

    const cp1x = p1.x + (p2.x - p0.x) / 6;
    const cp1y = p1.y + (p2.y - p0.y) / 6;
    const cp2x = p2.x - (p3.x - p1.x) / 6;
    const cp2y = p2.y - (p3.y - p1.y) / 6;

    d += `C ${cp1x},${cp1y} ${cp2x},${cp2y} ${p2.x},${p2.y} `;
  }

  return d;
}

function EvolutionChart({ data = [] }) {
  const width = 900;
  const height = 260;
  const padding = { top: 24, right: 20, bottom: 40, left: 50 };

  const points = data.filter(
    (item) =>
      Number.isFinite(Number(item.carburant)) &&
      Number.isFinite(Number(item.conso))
  );

  if (!points.length) {
    return (
      <div
        style={{
          height: 220,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Empty description="Pas assez de données pour afficher l'évolution" />
      </div>
    );
  }

  const maxConso = Math.max(...points.map((p) => Number(p.conso)), 1) * 1.15;
  const maxCarburant =
    Math.max(...points.map((p) => Number(p.carburant)), 1) * 1.15;

  const innerWidth = width - padding.left - padding.right;
  const innerHeight = height - padding.top - padding.bottom;

  const x = (index) =>
    padding.left +
    (points.length === 1
      ? innerWidth / 2
      : (index / (points.length - 1)) * innerWidth);

  const yConso = (value) =>
    padding.top + innerHeight - (Number(value) / maxConso) * innerHeight;

  const yCarburant = (value) =>
    padding.top + innerHeight - (Number(value) / maxCarburant) * innerHeight;

  const consoCoords = points.map((p, index) => ({
    x: x(index),
    y: yConso(p.conso),
  }));

  const carburantCoords = points.map((p, index) => ({
    x: x(index),
    y: yCarburant(p.carburant),
  }));

  const consoLine = buildSmoothPath(consoCoords);
  const carburantLine = buildSmoothPath(carburantCoords);

  const baseline = padding.top + innerHeight;
  const consoArea =
    consoCoords.length > 1
      ? `${consoLine} L ${consoCoords[consoCoords.length - 1].x},${baseline} L ${consoCoords[0].x},${baseline} Z`
      : "";

  const gridLines = 4;

  return (
    <div style={{ width: "100%" }}>
      <svg
        viewBox={`0 0 ${width} ${height}`}
        width="100%"
        height={height}
        preserveAspectRatio="none"
        style={{ display: "block" }}
      >
        <defs>
          <linearGradient id="consoAreaFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#1677ff" stopOpacity="0.28" />
            <stop offset="100%" stopColor="#1677ff" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Grille horizontale */}
        {Array.from({ length: gridLines + 1 }).map((_, i) => {
          const ratio = i / gridLines;
          const y = padding.top + innerHeight * ratio;

          return (
            <line
              key={`grid-${i}`}
              x1={padding.left}
              x2={width - padding.right}
              y1={y}
              y2={y}
              stroke="#eef2f7"
              strokeWidth="1"
            />
          );
        })}

        {/* Axe vertical consommation */}
        {Array.from({ length: gridLines + 1 }).map((_, i) => {
          const value = maxConso * (1 - i / gridLines);
          const y = padding.top + innerHeight * (i / gridLines);

          return (
            <text
              key={`conso-axis-${i}`}
              x={padding.left - 8}
              y={y + 4}
              textAnchor="end"
              fontSize="11"
              fill="#9aa5b1"
            >
              {formatNumber(value, 0)}
            </text>
          );
        })}

        {/* Zone sous la courbe de consommation */}
        {consoArea ? <path d={consoArea} fill="url(#consoAreaFill)" stroke="none" /> : null}

        {/* Courbe carburant L (repère secondaire, en arrière-plan) */}
        <path
          d={carburantLine}
          fill="none"
          stroke="#fa8c16"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="5 5"
          opacity="0.85"
        />

        {/* Courbe consommation L/100 km (indicateur principal) */}
        <path
          d={consoLine}
          fill="none"
          stroke="#1677ff"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Points consommation */}
        {points.map((p, index) => (
          <g key={`point-${index}`}>
            <circle
              cx={x(index)}
              cy={yConso(p.conso)}
              r="5"
              fill="#fff"
              stroke="#1677ff"
              strokeWidth="3"
            />
            <title>{`${p.date}: ${formatNumber(p.conso, 2)} L/100 km`}</title>
          </g>
        ))}

        {/* Points carburant */}
        {points.map((p, index) => (
          <g key={`fuel-point-${index}`}>
            <circle
              cx={x(index)}
              cy={yCarburant(p.carburant)}
              r="3.5"
              fill="#fff"
              stroke="#fa8c16"
              strokeWidth="2"
            />
            <title>{`${p.date}: ${formatNumber(p.carburant, 1)} L`}</title>
          </g>
        ))}

        {/* Labels horizontaux */}
        {points.map((p, index) => {
          if (
            points.length > 8 &&
            index !== 0 &&
            index !== points.length - 1 &&
            index % Math.ceil(points.length / 7) !== 0
          ) {
            return null;
          }

          return (
            <text
              key={`label-${index}`}
              x={x(index)}
              y={height - 12}
              textAnchor="middle"
              fontSize="11"
              fill="#9aa5b1"
            >
              {p.date}
            </text>
          );
        })}
      </svg>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 24,
          marginTop: 2,
          fontSize: 12,
          color: "#687386",
        }}
      >
        <span>
          <span
            style={{
              display: "inline-block",
              width: 22,
              height: 3,
              background: "#1677ff",
              verticalAlign: "middle",
              marginRight: 7,
            }}
          />
          Consommation L/100 km
        </span>
        <span>
          <span
            style={{
              display: "inline-block",
              width: 22,
              height: 0,
              borderTop: "2.5px dashed #fa8c16",
              verticalAlign: "middle",
              marginRight: 7,
            }}
          />
          Carburant consommé L
        </span>
      </div>
    </div>
  );
}

export default function ConsommationCarburant({ camionIdLocked = null }) {
  const [camions, setCamions] = useState([]);
  const [camionId, setCamionId] = useState(camionIdLocked);
  const [periode, setPeriode] = useState([
    moment().startOf("month"),
    moment(),
  ]);

  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [data, setData] = useState(null);

  /* ---------------------------------------------------------------------- */
  /* Liste camions                                                         */
  /* ---------------------------------------------------------------------- */

  useEffect(() => {
    if (camionIdLocked) return;

    get_Camion()
      .then((res) => setCamions(res?.data || res || []))
      .catch(() => setCamions([]));
  }, [camionIdLocked]);

  useEffect(() => {
    if (camionIdLocked) {
      setCamionId(camionIdLocked);
    }
  }, [camionIdLocked]);

  const buildParams = useCallback(() => {
    const [start, end] = periode || [];

    return {
      camion_id: camionId || undefined,
      start_date: start ? start.format(FORMAT_API) : undefined,
      end_date: end ? end.format(FORMAT_API) : undefined,
    };
  }, [camionId, periode]);

  /* ---------------------------------------------------------------------- */
  /* Chargement                                                             */
  /* ---------------------------------------------------------------------- */

  const fetchData = useCallback(() => {
    setLoading(true);

    get_ConsommationCarburant(buildParams())
      .then((res) => setData(res?.data || null))
      .catch(() => {
        message.error("Impossible de charger la consommation carburant.");
        setData(null);
      })
      .finally(() => setLoading(false));
  }, [buildParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  /* ---------------------------------------------------------------------- */
  /* Export Excel                                                           */
  /* ---------------------------------------------------------------------- */

  const handleExport = async () => {
    setExporting(true);

    try {
      const blob = await export_ConsommationCarburant(buildParams());
      const url = window.URL.createObjectURL(blob);
      const [start, end] = periode || [];

      const nomFichier = `consommation_carburant_${
        start ? start.format(FORMAT_API) : "debut"
      }_${end ? end.format(FORMAT_API) : "fin"}.xlsx`;

      const lien = document.createElement("a");
      lien.href = url;
      lien.download = nomFichier;
      document.body.appendChild(lien);
      lien.click();
      lien.remove();
      window.URL.revokeObjectURL(url);

      message.success("Export Excel généré.");
    } catch (error) {
      message.error("Erreur lors de la génération de l'export Excel.");
    } finally {
      setExporting(false);
    }
  };

  /* ---------------------------------------------------------------------- */
  /* KPIs                                                                   */
  /* ---------------------------------------------------------------------- */

  const kpis = useMemo(() => {
    const parCamion = data?.par_camion || [];

    const distance = parCamion.reduce(
      (s, c) => s + Number(c.distance_totale_km || 0),
      0
    );

    const carburant = parCamion.reduce(
      (s, c) => s + Number(c.carburant_total_l || 0),
      0
    );

    const nbTrajets = parCamion.reduce(
      (s, c) => s + Number(c.nb_trajets || 0),
      0
    );

    return {
      distance,
      carburant,
      nbTrajets,
      nbCamions: parCamion.length,
      consoMoyenne:
        distance > 0
          ? Math.round((carburant / distance) * 100 * 100) / 100
          : null,
    };
  }, [data]);

  /* ---------------------------------------------------------------------- */
  /* Données du graphique d'évolution                                      */
  /* ---------------------------------------------------------------------- */

  const evolutionData = useMemo(() => {
    const details = data?.detail_trajets || [];

    const grouped = {};

    details.forEach((row) => {
      const date = getDateKey(row);
      const carburant = Number(row?.carburant_consomme);
      const distance = Number(row?.distance_km);

      if (!date || !Number.isFinite(carburant) || !Number.isFinite(distance)) {
        return;
      }

      if (!grouped[date]) {
        grouped[date] = {
          date,
          carburant: 0,
          distance: 0,
        };
      }

      grouped[date].carburant += carburant;
      grouped[date].distance += distance;
    });

    return Object.values(grouped)
      .map((item) => ({
        ...item,
        conso:
          item.distance > 0
            ? (item.carburant / item.distance) * 100
            : 0,
      }))
      .sort((a, b) => {
        const da = moment(a.date, "DD/MM");
        const db = moment(b.date, "DD/MM");
        return da.valueOf() - db.valueOf();
      });
  }, [data]);

  /* ---------------------------------------------------------------------- */
  /* Colonnes tableaux                                                      */
  /* ---------------------------------------------------------------------- */

  const colonnesParCamion = [
    {
      title: "Camion",
      dataIndex: "camion_id",
      key: "camion_id",
      width: 90,
      sorter: (a, b) => a.camion_id - b.camion_id,
      render: (v) => <Tag icon={<CarOutlined />} color="blue">{v}</Tag>,
    },
    {
      title: "Trajets",
      dataIndex: "nb_trajets",
      key: "nb_trajets",
      width: 90,
      sorter: (a, b) => a.nb_trajets - b.nb_trajets,
    },
    {
      title: "Distance totale (km)",
      dataIndex: "distance_totale_km",
      key: "distance_totale_km",
      width: 135,
      sorter: (a, b) => a.distance_totale_km - b.distance_totale_km,
      render: (v) => (
        <strong>{formatNumber(v, 0)} km</strong>
      ),
    },
    {
      title: "Carburant total (L)",
      dataIndex: "carburant_total_l",
      key: "carburant_total_l",
      width: 135,
      sorter: (a, b) => a.carburant_total_l - b.carburant_total_l,
      render: (v) => (
        <span style={{ color: "#d46b08", fontWeight: 600 }}>
          <FireOutlined style={{ marginRight: 5 }} />
          {formatNumber(v, 1)} L
        </span>
      ),
    },
    {
      title: "Conso moyenne (L/100km)",
      dataIndex: "conso_moyenne_l_100km",
      key: "conso_moyenne_l_100km",
      width: 120,
      sorter: (a, b) =>
        (a.conso_moyenne_l_100km || 0) -
        (b.conso_moyenne_l_100km || 0),
      render: (v) =>
        v != null ? (
          <Tag color={v > 40 ? "red" : v > 30 ? "orange" : "green"}>
            {formatNumber(v, 2)} L/100km
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Carburant moyen / trajet (L)",
      dataIndex: "carburant_moyen_par_trajet",
      key: "carburant_moyen_par_trajet",
      width: 125,
      render: (v) => `${formatNumber(v, 1)} L`,
    },
  ];

  const colonnesAllerRetour = [
    {
      title: "Facture",
      dataIndex: "facture_id",
      key: "facture_id",
      width: 95,
      render: (v) => (v ? <Tag color="geekblue">#{v}</Tag> : "-"),
    },
    {
      title: "Camion",
      dataIndex: "camion_id",
      key: "camion_id",
      width: 90,
    },
    {
      title: "Distance aller (km)",
      dataIndex: "distance_aller_km",
      key: "distance_aller_km",
      width: 125,
      render: (v) => formatNumber(v, 0),
    },
    {
      title: "Carburant aller (L)",
      dataIndex: "carburant_aller_l",
      key: "carburant_aller_l",
      width: 125,
      render: (v) => `${formatNumber(v, 1)} L`,
    },
    {
      title: "Conso aller",
      dataIndex: "conso_aller_l_100km",
      key: "conso_aller_l_100km",
      width: 120,
      render: (v) =>
        v != null ? (
          <Tag color="blue">{formatNumber(v, 2)} L/100km</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Distance retour (km)",
      dataIndex: "distance_retour_km",
      key: "distance_retour_km",
      width: 125,
      render: (v) => formatNumber(v, 0),
    },
    {
      title: "Carburant retour (L)",
      dataIndex: "carburant_retour_l",
      key: "carburant_retour_l",
      width: 125,
      render: (v) => `${formatNumber(v, 1)} L`,
    },
    {
      title: "Conso retour",
      dataIndex: "conso_retour_l_100km",
      key: "conso_retour_l_100km",
      width: 120,
      render: (v) =>
        v != null ? (
          <Tag color="green">{formatNumber(v, 2)} L/100km</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Conso globale",
      dataIndex: "conso_globale_l_100km",
      key: "conso_globale_l_100km",
      width: 135,
      render: (v) =>
        v != null ? (
          <Tag color="purple">{formatNumber(v, 2)} L/100km</Tag>
        ) : (
          "-"
        ),
    },
  ];

  const colonnesDetail = [
    {
      title: "Trajet",
      dataIndex: "trajet_id",
      key: "trajet_id",
      width: 85,
      render: (v) => <Tag color="cyan">#{v}</Tag>,
    },
    {
      title: "Camion",
      dataIndex: "camion_id",
      key: "camion_id",
      width: 90,
    },
    {
      title: "Facture",
      dataIndex: "facture_id",
      key: "facture_id",
      width: 95,
      render: (v) => (v ? <Tag color="geekblue">#{v}</Tag> : "-"),
    },
    {
      title: "Sens",
      dataIndex: "sens",
      key: "sens",
      width: 105,
      filters: Object.entries(SENS_TAG).map(([value, { label }]) => ({
        text: label,
        value,
      })),
      onFilter: (value, record) => record.sens === value,
      render: (sens) => {
        const cfg = SENS_TAG[sens] || {
          color: "default",
          label: sens || "-",
        };

        return <Tag color={cfg.color}>{cfg.label}</Tag>;
      },
    },
    {
      title: "Départ",
      dataIndex: "date_depart",
      key: "date_depart",
      width: 135,
    },
    {
      title: "Arrivée",
      dataIndex: "date_arrive",
      key: "date_arrive",
      width: 135,
    },
    {
      title: "Distance (km)",
      dataIndex: "distance_km",
      key: "distance_km",
      width: 145,
      sorter: (a, b) => a.distance_km - b.distance_km,
      render: (v) => `${formatNumber(v, 0)} km`,
    },
    {
      title: "Carburant (L)",
      dataIndex: "carburant_consomme",
      key: "carburant_consomme",
      width: 115,
      render: (v) => (
        <span style={{ fontWeight: 600, color: "#d46b08" }}>
          {formatNumber(v, 1)} L
        </span>
      ),
    },
    {
      title: "Conso (L/100km)",
      dataIndex: "conso_l_100km",
      key: "conso_l_100km",
      width: 135,
      sorter: (a, b) =>
        (a.conso_l_100km || 0) - (b.conso_l_100km || 0),
      render: (v) =>
        v != null ? (
          <Tag color={v > 40 ? "red" : v > 30 ? "orange" : "blue"}>
            {formatNumber(v, 2)} L/100km
          </Tag>
        ) : (
          "-"
        ),
    },
  ];

  /* ---------------------------------------------------------------------- */
  /* Onglets principaux : Évolution (courbe) / Tableaux (détails)          */
  /* ---------------------------------------------------------------------- */

  const mainTabItems = [
    {
      key: "evolution",
      label: (
        <span style={{ fontWeight: 600 }}>
          <LineChartOutlined style={{ marginRight: 6 }} />
          Évolution
        </span>
      ),
      children: (
        <Card
          bordered={false}
          style={{
            borderRadius: 14,
            boxShadow: "0 4px 16px rgba(15, 23, 42, 0.07)",
            background:
              "linear-gradient(180deg, #f7faff 0%, #ffffff 60%)",
          }}
          bodyStyle={{ padding: "14px 18px 8px" }}
          title={
            <span style={{ fontWeight: 650 }}>
              <LineChartOutlined style={{ marginRight: 8, color: "#1677ff" }} />
              Évolution de la consommation
            </span>
          }
          extra={
            kpis.consoMoyenne != null ? (
              <Tag color="blue" style={{ borderRadius: 6 }}>
                Moyenne : {formatNumber(kpis.consoMoyenne, 2)} L/100 km
              </Tag>
            ) : null
          }
        >
          <EvolutionChart data={evolutionData} />
        </Card>
      ),
    },
    {
      key: "tableaux",
      label: (
        <span style={{ fontWeight: 600 }}>
          <TableOutlined style={{ marginRight: 6 }} />
          Tableaux
        </span>
      ),
      children: (
        <Card
          bordered={false}
          style={{
            borderRadius: 14,
            boxShadow: "0 4px 16px rgba(15, 23, 42, 0.07)",
          }}
          bodyStyle={{ padding: 0 }}
        >
          <Tabs
            defaultActiveKey="par_camion"
            style={{ padding: "8px 18px 0" }}
            items={[
              {
                key: "par_camion",
                label: (
                  <span>
                    <CarOutlined /> Par camion
                  </span>
                ),
                children: (
                  <Table
                    rowKey="camion_id"
                    loading={loading}
                    columns={colonnesParCamion}
                    dataSource={data?.par_camion || []}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      showTotal: (total) => `${total} camion(s)`,
                    }}
                    locale={{
                      emptyText: (
                        <Empty description="Aucune donnée sur la période" />
                      ),
                    }}
                    tableLayout="fixed"
                    size="small"
                    bordered
                    className="consommation-table"
                  />
                ),
              },
              {
                key: "aller_retour",
                label: "Aller / Retour",
                children: (
                  <Table
                    rowKey={(record) =>
                      `${record.facture_id || "sans-facture"}-${record.camion_id}`
                    }
                    loading={loading}
                    columns={colonnesAllerRetour}
                    dataSource={data?.par_voyage || []}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      showTotal: (total) => `${total} voyage(s)`,
                    }}
                    locale={{
                      emptyText: (
                        <Empty description="Aucune donnée sur la période" />
                      ),
                    }}
                    tableLayout="fixed"
                    size="small"
                    bordered
                    className="consommation-table"
                  />
                ),
              },
              {
                key: "detail",
                label: "Détail des trajets",
                children: (
                  <Table
                    rowKey="trajet_id"
                    loading={loading}
                    columns={colonnesDetail}
                    dataSource={data?.detail_trajets || []}
                    pagination={{
                      pageSize: 15,
                      showSizeChanger: true,
                      showTotal: (total) => `${total} trajet(s)`,
                    }}
                    locale={{
                      emptyText: (
                        <Empty description="Aucune donnée sur la période" />
                      ),
                    }}
                    tableLayout="fixed"
                    size="small"
                    bordered
                    className="consommation-table"
                  />
                ),
              },
            ]}
          />
        </Card>
      ),
    },
  ];

  return (
    <>
      <style>{`
        .consommation-table .ant-table { font-size: 12px; }
        .consommation-table .ant-table-thead > tr > th {
          background: #f0f5ff !important;
          color: #17365d;
          font-weight: 700;
          padding: 7px 6px !important;
          white-space: normal;
          line-height: 1.2;
        }
        .consommation-table .ant-table-tbody > tr > td {
          padding: 7px 6px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .consommation-table .ant-table-tbody > tr:hover > td {
          background: #f6faff !important;
        }
        .consommation-table .ant-table-container { overflow-x: hidden !important; }

        .consommation-main-tabs .ant-tabs-nav {
          margin-bottom: 14px;
        }
        .consommation-main-tabs .ant-tabs-tab {
          padding: 9px 18px !important;
          border-radius: 10px 10px 0 0 !important;
        }
        .consommation-main-tabs .ant-tabs-tab-active {
          background: #ffffff !important;
        }
      `}</style>
      <div
        style={{
          width: "100%",
          minWidth: 0,
          padding: 16,
          background:
            "linear-gradient(180deg, #f5f8fc 0%, #ffffff 42%)",
          borderRadius: 12,
        }}
      >
        {/* ------------------------------------------------------------------ */}
        {/* En-tête                                                            */}
        {/* ------------------------------------------------------------------ */}
        <div
          style={{
            marginBottom: 16,
            padding: "18px 20px",
            borderRadius: 12,
            background:
              "linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)",
            color: "#fff",
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
          }}
        >
          <Row align="middle" justify="space-between" gutter={[16, 16]}>
            <Col>
              <div style={{ fontSize: 21, fontWeight: 700 }}>
                <FireOutlined style={{ marginRight: 9 }} />
                Consommation carburant
              </div>
              <div
                style={{
                  marginTop: 4,
                  opacity: 0.82,
                  fontSize: 13,
                }}
              >
                Suivi des consommations, distances et évolution des performances
              </div>
            </Col>

            <Col>
              <Tag
                color="blue"
                style={{
                  border: "none",
                  padding: "5px 11px",
                  borderRadius: 8,
                }}
              >
                <LineChartOutlined /> Analyse
              </Tag>
            </Col>
          </Row>
        </div>

        {/* ------------------------------------------------------------------ */}
        {/* Filtres                                                            */}
        {/* ------------------------------------------------------------------ */}
        <Card
          bordered={false}
          style={{
            marginBottom: 16,
            borderRadius: 12,
            boxShadow: "0 3px 14px rgba(15, 23, 42, 0.06)",
          }}
          bodyStyle={{ padding: 18 }}
        >
          <Row gutter={[16, 16]} align="middle" justify="space-between">
            <Col flex="auto">
              <Space wrap size="middle">
                {!camionIdLocked && (
                  <Select
                    allowClear
                    showSearch
                    placeholder="Tous les camions"
                    style={{ width: 230 }}
                    value={camionId || undefined}
                    onChange={(v) => setCamionId(v)}
                    optionFilterProp="children"
                  >
                    {camions.map((c) => (
                      <Select.Option key={c.id} value={c.id}>
                        {c.imm || c.reference || `Camion #${c.id}`}
                      </Select.Option>
                    ))}
                  </Select>
                )}

                <RangePicker
                  value={periode}
                  onChange={(v) => setPeriode(v)}
                  format="DD/MM/YYYY"
                  allowClear={false}
                />

                <Button
                  type="primary"
                  icon={<ReloadOutlined />}
                  onClick={fetchData}
                  loading={loading}
                >
                  Rechercher
                </Button>
              </Space>
            </Col>

            <Col>
              <Tooltip title="Génère un fichier Excel avec les filtres actuels">
                <Button
                  icon={<DownloadOutlined />}
                  onClick={handleExport}
                  loading={exporting}
                >
                  Exporter en Excel
                </Button>
              </Tooltip>
            </Col>
          </Row>
        </Card>

        {/* ------------------------------------------------------------------ */}
        {/* KPIs                                                                */}
        {/* ------------------------------------------------------------------ */}
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={12} md={6}>
            <KpiCard
              gradient={KPI_THEME.trajets.gradient}
              icon={<EnvironmentOutlined />}
              title="Trajets"
              value={formatNumber(kpis.nbTrajets, 0)}
              subtitle={`${kpis.nbCamions} camion(s)`}
              loading={loading}
            />
          </Col>

          <Col xs={12} md={6}>
            <KpiCard
              gradient={KPI_THEME.distance.gradient}
              icon={<DashboardOutlined />}
              title="Distance totale"
              value={formatNumber(kpis.distance, 0)}
              suffix="km"
              subtitle={
                kpis.nbTrajets > 0
                  ? `${formatNumber(kpis.distance / kpis.nbTrajets, 0)} km / trajet`
                  : undefined
              }
              loading={loading}
            />
          </Col>

          <Col xs={12} md={6}>
            <KpiCard
              gradient={KPI_THEME.carburant.gradient}
              icon={<FireOutlined />}
              title="Carburant total"
              value={formatNumber(kpis.carburant, 1)}
              suffix="L"
              subtitle={
                kpis.nbCamions > 0
                  ? `${formatNumber(kpis.carburant / kpis.nbCamions, 1)} L / camion`
                  : undefined
              }
              loading={loading}
            />
          </Col>

          <Col xs={12} md={6}>
            <KpiCard
              gradient={KPI_THEME.conso.gradient}
              icon={<LineChartOutlined />}
              title="Consommation moyenne"
              value={
                kpis.consoMoyenne != null
                  ? formatNumber(kpis.consoMoyenne, 2)
                  : "-"
              }
              suffix={kpis.consoMoyenne != null ? "L/100 km" : ""}
              subtitle="sur la période sélectionnée"
              loading={loading}
            />
          </Col>
        </Row>

        {/* ------------------------------------------------------------------ */}
        {/* Onglets : Évolution / Tableaux                                     */}
        {/* ------------------------------------------------------------------ */}
        <Tabs
          className="consommation-main-tabs"
          type="card"
          defaultActiveKey="evolution"
          items={mainTabItems}
        />
      </div>
    </>
  );
}